import React from "react";
import PropTypes from "prop-types";
import { BadgeWrapper } from "./Badge.styled";
import { getBadgeVariant } from "utils/getBadgeVariant";

const Badge = ({ children, variant, value }) => {
  const badgeVariant = variant || getBadgeVariant(value);
  return <BadgeWrapper variant={badgeVariant}>{children}</BadgeWrapper>;
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["positive", "primary", "secondary", "neutral"]),
  value: PropTypes.string
};

export default Badge;
